import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import ViewTicketModal from "./ViewTicketModal";
import CancelTicketModal from "./CancelTicketModal";

const PurchasedProducts = ({
  item,
  onCancelTicket,
  isCancelTicket,
  setCancelTicket,
  onOpenCancelModal
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [reasonText, setReasonText] = useState("");
  const reservation = item?.typeOfBooking;

  const handleOnClickView = (item) => {
    setIsModalOpen(!isModalOpen);
    const modalInfo = [];
    modalInfo.push(item);
    setModalData(modalInfo);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const closeTicketModal = () => {
    setCancelTicket(false);
  };
  const getReservationDate = (date) => {
    const inputDate = new Date(date);
    const options = { year: "numeric", month: "short", day: "numeric" };
    const formattedDate = inputDate.toLocaleDateString(undefined, options);
    return formattedDate;
  };
  const manageTextinput = (event) => {
    setReasonText(event.target.value);
  };
  const getStatusBgColor = (tag) => {
    let bgColor;
    switch (tag) {
      case "upcoming":
        bgColor = Colors.orange;
        break;
      case "pending":
        bgColor = Colors.red;
        break;
      default:
        bgColor = Colors.orange;
        break;
    }
    return bgColor;
  };

  return (
    <AddedProductsContainer>
      <ProductValues
        style={{ width: "11%", justifyContent: "center", display: "flex" }}
      >
        <ProductImage src={item?.img} />
      </ProductValues>
      <ProductValues style={{ width: "18%" }}>
        {reservation === "reservation" ? item?.reference_code : item?.ticketNo}
      </ProductValues>
      <ProductValues style={{ width: "22%" }}>
        {reservation === "reservation"
          ? getReservationDate(item?.date)
          : item?.visitTime}
      </ProductValues>
      <ProductMultiValues style={{ width: "18%" }}>
        {reservation === "reservation" ? (
          <ProductSubValues>{item?.venue}</ProductSubValues>
        ) : (
          item?.items?.map((item, index) => (
            <ProductSubValues key={index}>{item?.name}</ProductSubValues>
          ))
        )}
      </ProductMultiValues>
      {reservation !== "reservation" ? (
        <ProductMultiValues style={{ width: "15%" }}>
          {item?.items?.map((item, index) =>
            item?.slots?.length > 0 ? (
              item?.slots?.map((value, index) => (
                <ProductSubValues key={index}>
                  {value?.aquaDuration}
                  {" Min"}
                </ProductSubValues>
              ))
            ) : (
              <ProductSubValues key={index}>
                {item?.qty}
                {" Unit"}
              </ProductSubValues>
            )
          )}
        </ProductMultiValues>
      ) : (
        <ProductAnchorValues
          style={{ textDecoration: "none", fontSize: "1rem", width: "15%" }}
          color={Colors.black}
        >
          -
        </ProductAnchorValues>
      )}
      {reservation === "reservation" ? (
        <ProductAnchorValues
          style={{ textDecoration: "none", fontSize: "1rem" }}
          color={Colors.black}
        >
          -
        </ProductAnchorValues>
      ) : (
        <ProductButtonStatus bgcolor={getStatusBgColor(item?.tag)}>
          {item?.tag?.toLocaleUpperCase()}
        </ProductButtonStatus>
      )}

      {item?.isCancellationEnabled ? (
        <ProductAnchorValues
          color={Colors.red}
          onClick={() => onOpenCancelModal(item?._id)}
        >
          Cancel ticket
        </ProductAnchorValues>
      ) : (
        <ProductAnchorValues
          style={{ textDecoration: "none", fontSize: "1rem" }}
          color={Colors.black}
        >
          -
        </ProductAnchorValues>
      )}
      <ProductAnchorValues
        color={Colors.lightBlue}
        onClick={() => handleOnClickView(item)}
      >
        View
      </ProductAnchorValues>
      <ViewTicketModal isModalOpen={isModalOpen} closeModal={closeModal} modalData={modalData} onOpenCancelModal={onOpenCancelModal}/>
      <CancelTicketModal isCancelTicket={isCancelTicket} closeTicketModal={closeTicketModal} manageTextinput={manageTextinput} onCancelTicket={onCancelTicket} reasonText={reasonText}/>
    </AddedProductsContainer>
  );
};

const AddedProductsContainer = styled.div`
  padding: 1rem 0rem 1rem 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 1.5rem;
  border-bottom: 1px solid ${Colors.lightShadeBlue};
`;
const ProductValues = styled.span`
  color: ${Colors.arsenic};
  font-size: 0.8rem;
  font-weight: 400;
  width: 11%;
  height: 100%;
  display: flex;
  text-align: left;
`;
const ProductMultiValues = styled.div`
  width: 11%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`;
const ProductSubValues = styled.span`
  color: ${Colors.arsenic};
  font-size: 0.8rem;
  font-weight: 400;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
`;
const ProductAnchorValues = styled.span`
  color: ${(props) => props.color};
  font-size: 0.8rem;
  font-weight: 400;
  width: 13%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
`;
const ProductButtonStatus = styled.button`
  color: ${Colors.white};
  border: none;
  background-color: ${(props) => props.bgcolor};
  font-size: 0.8rem;
  font-weight: 400;
  width: 11%;
  height: 1.5rem;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  text-align: center;
  margin-right: 1rem;
  cursor: pointer;
`;
const ProductImage = styled.img`
  width: 2.5rem;
  height: 2.1rem;
`;

export default PurchasedProducts;
